var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-screen"},[(_vm.noUser)?_c('v-btn',{staticClass:"login-button",attrs:{"color":"secondary"},on:{"click":_vm.handleLoginClick}},[_vm._v("Log in with Stamen Google Account")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }